import { Fragment } from "react";
import { Field } from "formik";
import ReCAPTCHA from "react-google-recaptcha";
import { Button, Message } from "react-bulma-components";
import {
  Field as BulmaField,
  Label,
  Input,
  Control,
  Checkbox,
  Help
} from "react-bulma-components/lib/components/form";
import Link from "next/link";
import TagSelect from "../inputs/TagSelect";

import Icon from "../../components/Icon";

import {
  COLORS,
  RECAPTCHA_KEY,
  IMMEDIATELY,
  DAILY_DIGEST,
  WEEKLY_DIGEST,
  UNDEFINED
} from "../../constants";
import Select from "../../components/inputs/Select";
import { firebase } from "../../lib/firebase";
import "firebase/auth";

const frequencyOptions = [
  {
    label: "As soon as posted",
    value: IMMEDIATELY
  },
  {
    label: "Daily digest",
    value: DAILY_DIGEST
  },
  {
    label: "Weekly digest",
    value: WEEKLY_DIGEST
  }
];


const postSuccess = () => (
  <Message color={COLORS.SUCCESS}>
    <Message.Header>Saved successfully! Awaiting confirmation.</Message.Header>
    <Message.Body>
      We sent you an email. Please click the link inside to confirm your
      subscription.
    </Message.Body>
  </Message>
);

const preSuccess = ({
  values,
  touched,
  errors,
  setFieldValue,
  setFieldTouched,
  isSubmitting,
  submitForm,
  isValid
}) => {
  return (
    <Fragment>
      <BulmaField>
        <Label>Email</Label>
        <Control iconLeft>
          <Field name="email" as={Input} type="email" color={COLORS.INFO} />
          <Icon className="is-left" icon={["far", "envelope"]} size="small" />
          {touched.email && errors.email ? (
            <Help color={COLORS.DANGER}>{errors.email}</Help>
          ) : null}
        </Control>
      </BulmaField>
      <BulmaField>
        <Label>Frequency</Label>
        <Control>
          <Field
            name="frequency"
            as={Select}
            options={frequencyOptions}
            setFieldValue={setFieldValue}
            setFieldTouched={setFieldTouched}
          />
          <Help>How often do you want to receive these emails?</Help>
          {touched.frequency && errors.frequency ? (
            <Help color={COLORS.DANGER}>{errors.frequency}</Help>
          ) : null}
        </Control>
      </BulmaField>
      <BulmaField>
        <Label>Keywords</Label>
        <Control>
          <Field
            name="tags"
            as={TagSelect}
            setFieldValue={setFieldValue}
            setFieldTouched={setFieldTouched}
          ></Field>
          <Help>
            Pick the keywords that you want to hear about. Only the Jobs that
            match will be sent to you. Leave blank if you want to hear about all
            jobs.
          </Help>
          {touched.tags && errors.tags ? (
            <Help color={COLORS.DANGER}>{errors.tags}</Help>
          ) : null}
        </Control>
      </BulmaField>
      <BulmaField>
        <Control>
          <Field
            name="news"
            as={Checkbox}
            value="true"
            checked={values.news}
            color={COLORS.INFO}
            type="checkbox"
          >
            &nbsp;Send me new Blog posts, feature updates and important
            announcements
          </Field>
        </Control>
      </BulmaField>
      <BulmaField>
        <Control>
          <Field
            name="terms"
            as={Checkbox}
            value="true"
            checked={values.terms}
            color={COLORS.INFO}
            type="checkbox"
          >
            &nbsp;I agree to the{" "}
            <Link href="/policies/privacy" passHref>
              <a>Privacy Policy</a>
            </Link>
          </Field>
          {errors.terms && touched.terms ? (
            <Help color={COLORS.DANGER}>{errors.terms}</Help>
          ) : null}
        </Control>
      </BulmaField>
      <BulmaField>
        <Control>
          {/* <ReCAPTCHA
            ref={recaptchaRef}
            sitekey={RECAPTCHA_KEY}
            onChange={token => setFieldValue("recaptcha", token)}
            size="invisible"
            badge="bottomleft"
          />
          {errors.recaptcha && touched.recaptcha ? (
            <Help color={COLORS.DANGER}>{errors.recaptcha}</Help>
          ) : null} */}
        </Control>
      </BulmaField>
      {errors.server ? (
        <Help color={COLORS.DANGER}>{errors.server.join(" ")}</Help>
      ) : null}
      <BulmaField>
        <Button
          loading={isSubmitting}
          color={COLORS.SUCCESS}
          // outlined
          type="submit"
          onClick={() => {
            firebase.auth.verify
            if (isValid) {
              submitForm();
            }
          }}
        >
          <b>Subscribe</b>
        </Button>
      </BulmaField>
    </Fragment>
  );
};
const SubscribeForm = ({ success, ...props }) => {
  return success
    ? postSuccess()
    : preSuccess({
        ...props
      });
};

export default SubscribeForm;

export const submitSubscribe = ({
  inputValues,
  setErrors,
  setSuccess,
  setSubmitting
}) => {
  setSubmitting(true);
  commitMutation(createEnvironment(), {
    mutation: subscribeMutation,
    variables: {
      input: inputValues
    },
    onCompleted: (resp, errors) => {
      if (setSubmitting) setSubmitting(false);
      if (resp.subscribe && resp.subscribe.subscription) {
        setSuccess(true);
        if (typeof window.fbq !== UNDEFINED) {
          window.fbq("track", "CompleteRegistration", {
            content_category: "Newsletter",
            content_name: "Jobs"
          });
        }
        if (typeof gtag !== UNDEFINED) {
          gtag("event", "CompleteRegistration", {
            event_category: "Newsletter",
            event_label: "Jobs"
          });
        }
      } else if (resp.subscribe && resp.subscribe.errors && setErrors) {
        setErrors(transformFormMutationErrors(resp.subscribe.errors));
      } else if (!errors) {
        setSuccess(true);
        if (typeof window.fbq !== UNDEFINED) {
          window.fbq("track", "CompleteRegistration", {
            content_category: "Newsletter",
            content_name: "Jobs"
          });
        }
        if (typeof gtag !== UNDEFINED) {
          gtag("event", "CompleteRegistration", {
            event_category: "Newsletter",
            event_label: "Jobs"
          });
        }
      }
    },
    onError: err => {
      if (setSubmitting) setSubmitting(false);
      if (setErrors) setErrors({ server: [err.message] });
    }
  });
};
